import React from "react";
import PropTypes from "prop-types";

import FullStoryCard from "cards/containers/FullStoryCard";
import { MicrodataContext } from "config/contexts";

import aliasCropNames from "utils/aliasCropNames";

/**
 * A compatibility layer component that allows us to use the new <FullStoryCard>
 * with old stream fetching containers. The idea is that this is a temporary
 * stopgap that can allow us to launch the new story cards with more semantic
 * markup and microdata before the rest of the stream refactor to move the
 * needle on SEO.
 */
export default function CompatStoryCard(props) {
  const { story } = props;
  const isPermalink = !!props.permalinkId; // This is dumb but it's the only way to know if we're on a permalink page.

  const imageCropStory = aliasCropNames(story);

  /**
   * The wrapper div has some odd attributes that need documentation:
   * - id: <TopStories /> tracks pageviews by checking the id of a story element
   *     against the id of the story. In addition, GTM uses the id format to
   *     trigger custom events against.
   * - data-permalink: <TopStories /> uses data-permalink to update the URL against.
   *     This was previously stored as a hidden element on the page but Google was
   *     scraping that for search results.
   */
  return (
    <div
      className="story-card"
      data-permalink={story.permalink}
      data-story-id={story.id}
      id={story.id}
    >
      <MicrodataContext.Provider value={isPermalink && !props.index}>
        <FullStoryCard
          isFeatured={story.new_featured}
          {...props}
          story={imageCropStory}
        />
      </MicrodataContext.Provider>
    </div>
  );
}

CompatStoryCard.propTypes = {
  story: PropTypes.shape({
    permalink: PropTypes.string,
    id: PropTypes.string,
    new_featured: PropTypes.bool,
  }).isRequired,
  index: PropTypes.number,
  permalinkId: PropTypes.string,
};
